module.exports = __webpack_public_path__ + "img/3af69e9.png";